/**
 * Validation utility functions for form validation
 */

/**
 * Check if a value is considered empty for validation purposes.
 * When `allowZero` is true, numeric 0 is treated as a valid value.
 */
export const isEmptyValue = (value: any, allowZero = false): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "") ||
    (typeof value === "number" && (Number.isNaN(value) || (!allowZero && value === 0)))
  );
};

/**
 * Validate a collection of entries against mandatory fields
 */
export const validateEntryCollection = (
  entries: any[],
  mandatoryFields: string[],
  errorPrefix: string,
  collectionName: string,
  options?: { allowZeroFields?: string[] }
): { errors: string[]; isValid: boolean } => {
  const errors: string[] = [];
  let isValid = true;
  const allowZeroFields = new Set(options?.allowZeroFields ?? []);

  if (entries && entries.length > 0) {
    entries.forEach((entry: any, entryIndex: number) => {
      mandatoryFields?.forEach((field) => {
        const value = entry?.[field];
        if (isEmptyValue(value, allowZeroFields.has(field))) {
          const errorKey = `${errorPrefix}_${entryIndex}_${field}`;
          errors.push(errorKey);
          isValid = false;
        }
      });
    });
  } else {
    // At least one entry is required
    errors.push(collectionName);
    isValid = false;
  }

  return { errors, isValid };
};

/**
 * Validate storage details fields
 */
export const validateStorageDetails = (
  formData: any,
  mandatoryFields: string[]
): { errors: string[]; isValid: boolean } => {
  const errors: string[] = [];
  let isValid = true;

  mandatoryFields?.forEach((field) => {
    const value = formData?.[field];
    if (isEmptyValue(value)) {
      errors.push(field);
      isValid = false;
    }
  });

  return { errors, isValid };
};
